import React from 'react'
import { useRunRj } from 'react-rocketjump'
import { CalendarioOreLavorativeState } from './localstate/calendario-ore-lavorative'
import { default as BaseCalendar } from 'react-big-calendar'
import moment from 'moment'
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import { useMemo } from 'react'
import { useState } from 'react'
import { Field, Formik } from 'formik'
import {
  CheckboxField,
  DateField,
  InputField,
} from '../../components/Form/Fields'
import * as Yup from 'yup'

export default function CalendarioOreLavorative() {
  const [
    { list: oreLavorative, loading },
    { run: fetchOreLavorative, createMultiple, addDateRange, updateDateRange },
  ] = useRunRj(CalendarioOreLavorativeState)

  const [dateRange, setDateRange] = React.useState({
    start: moment().startOf('month').toDate(),
    end: moment().endOf('month').toDate(),
  })

  const [modalAdd, setModalAdd] = useState(false)
  const toggleModalAdd = () => setModalAdd(!modalAdd)

  const [modalUpdate, setModalUpdate] = useState(false)
  const toggleModalUpdate = () => setModalUpdate(!modalUpdate)

  const [selectedEvent, setSelectedEvent] = useState(null)

  const eventsMacchine = useMemo(() => {
    if (!oreLavorative) return []
    return oreLavorative.map((item) => ({
      start: moment(item.giorno).toDate(),
      end: moment(item.giorno).toDate(),
      title: item.ore_lavorative_macchine || 'Ore Lavorative',
      allDay: true,
      color: 'red',
      id: item.id,
    }))
  }, [oreLavorative])

  const eventsMacchineAlluminio = useMemo(() => {
    if (!oreLavorative) return []
    return oreLavorative.map((item) => ({
      start: moment(item.giorno).toDate(),
      end: moment(item.giorno).toDate(),
      title: item.ore_lavorative_macchine_alluminio || 'Ore Lavorative Alluminio',
      allDay: true,
      color: 'orange',
      id: item.id,
    }))
  }, [oreLavorative])

  const eventsBanchi = useMemo(() => {
    if (!oreLavorative) return []
    return oreLavorative.map((item) => ({
      start: moment(item.giorno).toDate(),
      end: moment(item.giorno).toDate(),
      title: item.ore_lavorative_banchi || 'Ore Lavorative',
      allDay: true,
      color: 'blue',
      id: item.id,
    }))
  }, [oreLavorative])

  const eventsBanchiAlluminio = useMemo(() => {
    if (!oreLavorative) return []
    return oreLavorative.map((item) => ({
      start: moment(item.giorno).toDate(),
      end: moment(item.giorno).toDate(),
      title: item.ore_lavorative_banchi_alluminio || 'Ore Lavorative Alluminio',
      allDay: true,
      color: 'lightblue',
      id: item.id,
    }))
  }, [oreLavorative])


  const completeEvents = useMemo(() => {
    const filledEvents = []
    const start = moment(dateRange.start).startOf('day')
    const end = moment(dateRange.end).endOf('day')
    let currentDay = start.clone()

    while (currentDay.isSameOrBefore(end, 'day')) {
      const existing = oreLavorative?.find((e) =>
        moment(e.giorno).isSame(currentDay, 'day')
      )

      const isSunday = currentDay.day() === 0
      const isSaturday = currentDay.day() === 6

      if (existing) {
        filledEvents.push({
          start: moment(existing.giorno).toDate(),
          end: moment(existing.giorno).toDate(),
          title: `${existing.ore_lavorative_macchine}h Macchine`,
          allDay: true,
          color: 'darkred',
          id: existing.id + '_macchine',
          from_db: true,
        })
        filledEvents.push({
          start: moment(existing.giorno).toDate(),
          end: moment(existing.giorno).toDate(),
          title: `${existing.ore_lavorative_banchi}h Banchi`,
          allDay: true,
          color: 'darkblue',
          id: existing.id + '_banchi',
          from_db: true,
        })
        filledEvents.push({
          start: moment(existing.giorno).toDate(),
          end: moment(existing.giorno).toDate(),
          title: `${existing.ore_lavorative_macchine_alluminio}h Macchine Alluminio`,
          allDay: true,
          color: 'darkorange',
          id: existing.id + '_macchine_alluminio',
          from_db: true,
        })
        filledEvents.push({
          start: moment(existing.giorno).toDate(),
          end: moment(existing.giorno).toDate(),
          title: `${existing.ore_lavorative_banchi_alluminio}h Banchi Alluminio`,
          allDay: true,
          color: 'darkcyan',
          id: existing.id + '_banchi_alluminio',
          from_db: true,
        })
      } else if (!isSunday) {
        // Create default events for missing days
        const macchineHours = isSaturday ? 4 : 10
        const banchiHours = isSaturday ? 4 : 10
        const alluminioMacchineHours = isSaturday ? 4 : 10
        const alluminioBanchiHours = isSaturday ? 4 : 10

        filledEvents.push({
          start: currentDay.toDate(),
          end: currentDay.toDate(),
          title: `${macchineHours}h Macchine`,
          allDay: true,
          color: 'darkred',
          from_db: false,
        })
        filledEvents.push({
          start: currentDay.toDate(),
          end: currentDay.toDate(),
          title: `${banchiHours}h Banchi`,
          allDay: true,
          color: 'darkblue',
          from_db: false,
        })
        filledEvents.push({
          start: currentDay.toDate(),
          end: currentDay.toDate(),
          title: `${alluminioMacchineHours}h Macchine Alluminio`,
          allDay: true,
          color: 'darkorange',
          from_db: false,
        })
        filledEvents.push({
          start: currentDay.toDate(),
          end: currentDay.toDate(),
          title: `${alluminioBanchiHours}h Banchi Alluminio`,
          allDay: true,
          color: 'darkcyan',
          from_db: false,
        })
      }

      currentDay.add(1, 'day')
    }

    return filledEvents
  }, [oreLavorative, dateRange])


  // merge with existing events for one day can be only one event


  const validationSchema = Yup.object().shape({
    date_start: Yup.date().required('Data Inizio è obbligatoria'),
    date_end: Yup.date()
      .required('Data Fine è obbligatoria')
      .min(Yup.ref('date_start'), 'Data Fine deve essere dopo la Data Inizio'),
    // ore_lavorative required only if reset_default is false
    ore_lavorative_macchine: Yup.number()
      .when('reset_default', {
        is: false,
        then: Yup.number()
          .required('Ore Lavorative Macchine è obbligatoria')
          .min(0, 'Ore Lavorative Macchine non può essere negativa')
          .max(24, 'Ore Lavorative Macchine non può essere superiore a 24'),
      }),
    ore_lavorative_banchi: Yup.number()
      .when('reset_default', {
        is: false,
        then: Yup.number()
          .required('Ore Lavorative Banchi è obbligatoria')
          .min(0, 'Ore Lavorative Banchi non può essere negativa')
          .max(24, 'Ore Lavorative Banchi non può essere superiore a 24'),
      }),
    ore_lavorative_macchine_alluminio: Yup.number()
      .when('reset_default', {
        is: false,
        then: Yup.number()
          .required('Ore Lavorative Macchine Alluminio è obbligatoria')
          .min(0, 'Ore Lavorative Macchine Alluminio non può essere negativa')
          .max(24, 'Ore Lavorative Macchine Alluminio non può essere superiore a 24'),
      }),
    ore_lavorative_banchi_alluminio: Yup.number()
      .when('reset_default', {
        is: false,
        then: Yup.number()
          .required('Ore Lavorative Banchi Alluminio è obbligatoria')
          .min(0, 'Ore Lavorative Banchi Alluminio non può essere negativa')
          .max(24, 'Ore Lavorative Banchi Alluminio non può essere superiore a 24'),
      }),
  })

  const validationSchemaUpdate = Yup.object().shape({
    giorno: Yup.date().required('Data è obbligatoria'),
    ore_lavorative_banchi: Yup.number()
      .required('Ore Lavorative Banchi è obbligatoria')
      .min(0, 'Ore Lavorative Banchi non può essere negativa')
      .max(24, 'Ore Lavorative Banchi non può essere superiore a 24'),
    ore_lavorative_macchine: Yup.number()
      .required('Ore Lavorative Macchine è obbligatoria')
      .min(0, 'Ore Lavorative Macchine non può essere negativa')
      .max(24, 'Ore Lavorative Macchine non può essere superiore a 24'),
    ore_lavorative_banchi_alluminio: Yup.number()
      .required('Ore Lavorative Banchi Alluminio è obbligatoria')
      .min(0, 'Ore Lavorative Banchi Alluminio non può essere negativa')
      .max(24, 'Ore Lavorative Banchi Alluminio non può essere superiore a 24'),
    ore_lavorative_macchine_alluminio: Yup.number()
      .required('Ore Lavorative Macchine Alluminio è obbligatoria')
      .min(0, 'Ore Lavorative Macchine Alluminio non può essere negativa')
      .max(24, 'Ore Lavorative Macchine Alluminio non può essere superiore a 24'),
  })

  return (
    <div className="calendario-ore-lavorative">
      <div
        className="position-absolute bg-white d-flex justify-content-between align-items-center"
        style={{ right: 20, top: 80 }}
      >
        <button
          className="btn btn-primary"
          onClick={() => {
            toggleModalAdd()
          }}
        >
          Aggiorna Ore Lavorative
        </button>
      </div>
      {loading && <Spinner style={{ width: '3rem', height: '3rem' }} />}
      {!loading && (
        <BaseCalendar
          //    use the state dateRange to set the view
          defaultView="month"
          defaultDate={dateRange.start}
          localizer={BaseCalendar.momentLocalizer(moment)}
          onNavigate={(date, view) => {
            if (view === 'month') {
              setDateRange({
                start: moment(date).startOf('month').toDate(),
                end: moment(date).endOf('month').toDate(),
              })
            }
          }}
          events={completeEvents}
          startAccessor="start"
          //   only month view for simplicity
          views={['month']}
          // show all the events in the day cell
          showAllEvents={true}
          endAccessor="end"
          style={{ margin: '20px', height: 'calc(100vh - 200px)' }}
          onSelectEvent={(event) => {
            // search the event in the oreLavorative state with the start date
            const existing = oreLavorative.find((e) =>
              moment(e.giorno).isSame(moment(event.start), 'day') 
            )
            if (existing) {
              setSelectedEvent({
                ...event,
                ...existing,
              })
              toggleModalUpdate()
            } else {
              setSelectedEvent({
                ...event,
                giorno: moment(event.start).format('YYYY-MM-DD'),
                ore_lavorative_macchine: 10,
                ore_lavorative_banchi: 10,
                ore_lavorative_macchine_alluminio: 10,
                ore_lavorative_banchi_alluminio: 10,
              })
              toggleModalUpdate()
            }
          }}
          
          onSelectSlot={(slotInfo) => console.log(slotInfo)}
          //   change labels for today, previous, next, month
          messages={{
            today: 'Oggi',
            previous: 'Precedente',
            next: 'Successivo',
            month: 'Mese',
          }}
          //   style events
          eventPropGetter={(event) => ({
            // align on center of the cell

            style: {
              backgroundColor: event.color || '#3174ad',
              color: 'white',
              // width: 150,
              borderRadius: '5px',
              // padding: '2px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontSize: '0.9rem',
              tranform: 'translateY(-50%)',
              margin: '0 auto',
            },
          })}
        />
      )}

      <Modal isOpen={modalAdd} toggle={toggleModalAdd} centered size="md">
        <ModalHeader toggle={toggleModalAdd}>
          Aggiorna Ore Lavorative
        </ModalHeader>
        <ModalBody>
          <Formik
            validationSchema={validationSchema}
            enableReinitialize
            initialValues={{
              date_start: '',
              date_end: '',
              ore_lavorative_banchi: '',
              ore_lavorative_macchine: '',
              ore_lavorative_banchi_alluminio: '',
              ore_lavorative_macchine_alluminio: '',
              reset_default: false,
            }}
            onSubmit={(values, { setSubmitting }) => {
              return createMultiple
                .onSuccess(() => {
                  setSubmitting(false)
                  toggleModalAdd()
                  fetchOreLavorative()
                })
                .onFailure((error) => {
                  setSubmitting(false)
                  console.error('Error creating date range:', error)
                })
                .run(values)
            }}
          >
            {({ handleSubmit, isSubmitting, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <Field
                      label="Data Inizio"
                      name="date_start"
                      component={DateField}
                    />
                  </div>
                  <div className="col-md-12 mb-2">
                    <Field
                      label="Data Fine"
                      name="date_end"
                      component={DateField}
                    />
                  </div>
                  <div className="col-md-12 mb-2">
                    <Field
                      label="Ripristina default"
                      name="reset_default"
                      component={CheckboxField}
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      disabled={values.reset_default}
                      label="Ore Lavorative Macchine"
                      type="number"
                      name="ore_lavorative_macchine"
                      component={InputField}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      disabled={values.reset_default}
                      label="Ore Lavorative Banchi"
                      type="number"
                      name="ore_lavorative_banchi"
                      component={InputField}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      disabled={values.reset_default}
                      label="Ore Lavorative Macchine Alluminio"
                      type="number"
                      name="ore_lavorative_macchine_alluminio"
                      component={InputField}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12">
                    <Field
                      disabled={values.reset_default}
                      label="Ore Lavorative Banchi Alluminio"
                      type="number"
                      name="ore_lavorative_banchi_alluminio"
                      component={InputField}
                      className="form-control"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mt-3"
                  disabled={isSubmitting}
                >
                  Aggiorna
                </button>
              </form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      {selectedEvent && (
        <Modal
          isOpen={modalUpdate}
          toggle={toggleModalUpdate}
          centered
          size="md"
        >
          <ModalHeader toggle={toggleModalUpdate}>
            Modifica Ore Lavorative
          </ModalHeader>
          <ModalBody>
            <Formik
              validationSchema={validationSchemaUpdate}
              enableReinitialize
              initialValues={{
                giorno: selectedEvent.start,
                ore_lavorative_macchine: oreLavorative.find(
                  (item) => item.id === selectedEvent.id
                )?.ore_lavorative_macchine || '',
                ore_lavorative_banchi: oreLavorative.find(
                  (item) => item.id === selectedEvent.id
                )?.ore_lavorative_banchi || '',
                ore_lavorative_macchine_alluminio: oreLavorative.find(
                  (item) => item.id === selectedEvent.id
                )?.ore_lavorative_macchine_alluminio || '',
                ore_lavorative_banchi_alluminio: oreLavorative.find(
                  (item) => item.id === selectedEvent.id
                )?.ore_lavorative_banchi_alluminio || '',
              }}
              onSubmit={(values, { setSubmitting }) => {
                if (!selectedEvent) return
                if (selectedEvent.from_db) {
                  return updateDateRange
                    .onSuccess(() => {
                      setSubmitting(false)
                      toggleModalUpdate()
                      fetchOreLavorative()
                    })
                    .onFailure((error) => {
                      setSubmitting(false)
                      console.error('Error updating date range:', error)
                    })
                    .run({
                      ...values,
                      id: selectedEvent.id,
                      giorno: moment(values.giorno).format('YYYY-MM-DD'),
                    })
                } else {
                  return addDateRange
                    .onSuccess(() => {
                      setSubmitting(false)
                      toggleModalUpdate()
                      fetchOreLavorative()
                    })
                    .onFailure((error) => {
                      setSubmitting(false)
                      console.error('Error adding date range:', error)
                    })
                    .run({
                      ...values,
                      giorno: moment(values.giorno).format('YYYY-MM-DD'),
                    })
                }
              }}
            >
              {({ handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <Field label="Data" name="giorno" component={DateField} />
                    </div>
                    <div className="col-md-12">
                      <Field
                        label="Ore Lavorative Macchine"
                        type="number"
                        name="ore_lavorative_macchine"
                        component={InputField}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        label="Ore Lavorative Banchi"
                        type="number"
                        name="ore_lavorative_banchi"
                        component={InputField}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        label="Ore Lavorative Macchine Alluminio"
                        type="number"
                        name="ore_lavorative_macchine_alluminio"
                        component={InputField}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        label="Ore Lavorative Banchi Alluminio"
                        type="number"
                        name="ore_lavorative_banchi_alluminio"
                        component={InputField}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary mt-3"
                    disabled={isSubmitting}
                  >
                    Modifica
                  </button>
                </form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      )}
    </div>
  )
}